import { render, staticRenderFns } from "./OTP.vue?vue&type=template&id=3e471b22&"
import script from "./OTP.vue?vue&type=script&lang=js&"
export * from "./OTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports